import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const queryLogistics = async (data: object) => {
  return await POST({
    url: Api.queryLogistics,
    data,
    showError: false,
    headers: {
      'Content-Type': 'application/json',
      'Client-Id': 'iss_courier',
      rpcType: 'dubbo'
    }
  })
}
